import type * as CSS from 'csstype'
import { Box } from '@chakra-ui/react'
import type { ReactElement } from 'react'

interface Props {
  backgroundColor: CSS.Property.Color
}

const Shadow = ({ backgroundColor }: Props): ReactElement => (
  <>
    <Box
      position="sticky"
      top="-1.5rem"
      boxShadow="0px 2px 5px rgba(0,0,0, 16%)"
      zIndex={8}
      marginTop="calc(-1 * 1.5rem)"
      width="100%"
    >
      &nbsp;
    </Box>
    <Box
      position="sticky"
      top="-100px"
      background={`linear-gradient(${backgroundColor} 75%, transparent 100%)`}
      zIndex={9}
      marginTop="calc(-0.5 * 1.5rem)"
      width="100%"
    >
      &nbsp;
    </Box>
  </>
)

export default Shadow
